import { getAutomatedReleasesQuery } from '@gonfalon/rest-api/queries/automatedReleases';
import { getExperimentsQuery } from '@gonfalon/rest-api/queries/experiments';
import type { QueryClient } from '@tanstack/react-query';

/** Same query keys as `useDisabledTimeRanges` uses for rollout / experiment windows. */
export async function invalidateDependentQueries(
  queryClient: QueryClient,
  keys: { projectKey: string; environmentKey: string; resourceKey: string },
): Promise<void> {
  const { projectKey, environmentKey, resourceKey: flagKey } = keys;
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: getExperimentsQuery({
        projectKey,
        environmentKey,
        query: {
          filter: { flagKey },
          expand: ['previousIterations'],
          lifecycleState: ['active', 'archived'],
        },
      }).queryKey,
    }),
    queryClient.invalidateQueries({
      queryKey: getAutomatedReleasesQuery.partialQueryKey({ projectKey, flagKey }),
    }),
  ]);
}
